import React, { useState } from "react";
import styles from "./Dropdown.module.scss";

export default function Dropdown(props) {
  const { onChange, options, selectedValue } = props;

  const [selected, setSelected] = useState(
    selectedValue != null ? selectedValue : (
    options && options.length > 0 ? options[0].value : ""
    )
  );

  const handleChange = e => {
    onChange != null && onChange(e.target.value);
    setSelected(e.target.value);
  };

  return (
    <div className={styles.selectdiv}>
      <select value={selectedValue} onChange={handleChange} name="age">
        {options ? 
          options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option> 
          )) : null
        }
      </select>
    </div>
  );
}
